import React from 'react'
import { CustomFormulasRoute } from '../../PowerBICustomFormulas/CustomFormulasRoute'
import { IDatasetManagementScreenDefinitions } from './datasetManagementScreenTypes'
import { OutcomesRoute } from '../../Outcomes'
import { CustomFieldsRoute } from '../../PowerBiCustomFieldsMappings/CustomFieldsRoute'
import { TOGGLENAME } from '../../../ts/enums/releaseToggles'
import { FiscalCalendarRoute } from '../../FiscalCalendar/FiscalCalendarRoute'
import { EmplloyeeCountRoute } from '../../EmployeeCount/EmplloyeeCountRoute'
import { IPowerBiReports } from '../../../Models/GlobalState'

export const computeDatasetManagementDefinitions = (features: string[],toggles: string[],reportsLeftNavMenu: IPowerBiReports[]) : IDatasetManagementScreenDefinitions => {
    const definitions: IDatasetManagementScreenDefinitions = {
        Customformulas: {
            title: "Custom Formulas",
            getingPermission: "CustomFormulas",
            component: (props: any) => <CustomFormulasRoute {...props} toggles={toggles} />
        },
        CustomFieldMappings: {
            title: "Custom Fields",
            getingPermission: "CustomFieldMappingsEdit",
            component: (props: any) => <CustomFieldsRoute {...props} toggles={toggles} />,        
        },
        CustomCalendar: {
            title: "Custom Calendar",
            getingPermission: features.filter(item => item === "FiscalCalendar").length > 0 ? "FiscalCalendar" : "",
            component: (props: any) => <FiscalCalendarRoute {...props} toggles={toggles} />,
            featureName: features.filter(item => item === "FiscalCalendar").length > 0 ? "FiscalCalendar" : "",
        }
    };

    if (toggles.includes(TOGGLENAME.BENCHMARKINGCOMPONENT) && reportsLeftNavMenu.find(item => item.leftNavName === "NAVEX One Insights")) {
        definitions.EmployeeCount = {
            title: "Employee Count",
            getingPermission: "EmployeeCount",
            component: (props: any) => <EmplloyeeCountRoute {...props} toggles={toggles} />
        };
    }

    definitions.SubstantiatedTypeMapping = {
        title: "Outcomes",
        getingPermission: "OutcomeMappingsEdit",
        component: (props: any) => <OutcomesRoute {...props} toggles={toggles} />
    };
 
     
    return definitions;
}